import "./TodosLoading.css";

function TodosLoading() {
  return (
    <p>
      Almost there! ⌛️
      <br />
      Loading your data
    </p>
  );
}

export { TodosLoading };
